<div style="text-align: center; min-height: 100%; background-color: #f7f7f7">
	<router-outlet></router-outlet>
</div>
